export class Question {
  public _id: string;
  public ordinal: number;
  public questionLabel_fi: string;
  public questionLabel_sv: string;
  public questionLabel_en: string;
  public code: string;
  public answerAmount: number;
  public timeLimitSeconds: number;
  public answerArray: {
    answerLabel_fi: string;
    answerLabel_sv: string;
    answerLabel_en: string;
    score: number;
  }[];
  public scoreable: boolean;
}



// WEBPACK FOOTER //
// ./src/app/question.ts